<template>
    <v-app id="inspire">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <form @submit.prevent="submit">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>
                                        Confirm Authentication
                                    </v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <div v-if="! recovery">
                                        <v-text-field
                                            label="Code"
                                            id="code"
                                            ref="codeInput"
                                            v-model="form.code"
                                            type="text"
                                            inputmode="numeric"
                                            class="mt-1 block w-full"
                                            autofocus
                                            autocomplete="one-time-code"
                                            :hint="inputHint"
                                            persistent-hint
                                            :error-messages="errors.code"
                                        />
                                    </div>

                                    <div v-else>
                                        <v-text-field
                                            label="Recovery Code"
                                            id="recovery_code"
                                            ref="recoveryCodeInput"
                                            v-model="form.recovery_code"
                                            type="text"
                                            class="mt-1 block w-full"
                                            autocomplete="one-time-code"
                                            :error-messages="errors.recovery_code"
                                        />
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn
                                        color="green"
                                        type="button"
                                        @click.prevent="toggleRecovery"
                                    >
                                        <template v-if="! recovery">
                                            Use a recovery code
                                        </template>

                                        <template v-else>
                                            Use an authentication code
                                        </template>
                                    </v-btn>

                                    <v-btn
                                        type="submit"
                                        color="primary"
                                        :disabled="form.processing"
                                    >
                                        Log in
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import _ from 'lodash';

export default {
    props: {

    },

    data() {
        return {
            recovery: false,
            form: this.$inertia.form({
                code: '',
                recovery_code: '',
            }),
            recoveryCodeInput: null,
            codeInput: null,
        };
    },

    methods: {
        async toggleRecovery() {
            this.recovery ^= true;

            await this.$nextTick();

            if (this.recovery) {
                this.recoveryCodeInput.focus();
                this.form.code = '';
            } else {
                this.codeInput.focus();
                this.form.recovery_code = '';
            }
        },

        submit() {
            this.form.post(route('two-factor.login'));
        },
    },

    computed: {
        inputHint() {
            return this.recovery?
                'Please confirm access to your account by entering one of your emergency recovery codes.' :
                'Please confirm access to your account by entering the authentication code provided by your authenticator application.';
        },

        errors() {
            return {
                code: _.get(this.$page, 'props.errors.code', []),
                recovery_code: _.get(this.$page, 'props.errors.recovery_code', []),
            };
        }
    }
}
</script>

<style scoped>

</style>
